import type React from "react";
import { NotificationContext } from "./NotificationContext";
import { useFetch } from "../hooks/api";
import axios from "axios";
import { useAppSelector } from "../redux/hooks";
import type { Notification } from "./notificationConstants";

interface Props {
  children: React.ReactNode;
}

const NotificationProvider = ({ children }: Props) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const isEnabled = isAuthenticated && !!axios.defaults.headers.Authorization;
  const marketPlace =
    localStorage.Marketplace && localStorage.Marketplace !== "undefined" ? localStorage.Marketplace : "USA";

  const { data: notifications = [], isLoading } = useFetch<Notification[]>(
    ["notifications"],
    "/api/notifications/",
    {
      dismissed: false,
      market_place: marketPlace,
    },
    {
      enabled: isEnabled,
      refetchInterval: 60000,
      select: (data) => [...data.data].sort((a, b) => (a.ts ?? 0) - (b.ts ?? 0)),
    },
  );

  // oxlint-disable-next-line react/jsx-no-constructed-context-values
  return <NotificationContext.Provider value={{ notifications, isLoading }}>{children}</NotificationContext.Provider>;
};

export default NotificationProvider;
